import { type AppMode, useNeural } from "@/store/neuralStore";
import { Boxes, Crosshair, Gamepad2, Network, Rocket } from "lucide-react";
import { cn } from "@/lib/utils";

const MODES: { id: AppMode; label: string; icon: typeof Boxes; sub: string; hue: number }[] = [
  { id: "classic",  label: "Classic",   sub: "Command Center", icon: Network,    hue: 185 },
  { id: "game",     label: "Game",      sub: "Agents as heroes", icon: Gamepad2, hue: 145 },
  { id: "workflow", label: "Workflow",  sub: "React Flow",     icon: Boxes,      hue: 270 },
  { id: "space",    label: "3D Space",  sub: "Explorer",       icon: Rocket,     hue: 320 },
  { id: "mission",  label: "Mission",   sub: "War Room",       icon: Crosshair,  hue: 0 },
];

export function ModeSwitch() {
  const mode = useNeural((s) => s.mode);
  const setMode = useNeural((s) => s.setMode);

  return (
    <div
      role="tablist"
      aria-label="Mode switcher"
      data-testid="mode-switch"
      className="flex items-center gap-0.5 p-0.5 rounded-md bg-surface-2/80 border border-border"
    >
      {MODES.map((m) => {
        const Icon = m.icon;
        const active = mode === m.id;
        return (
          <button
            key={m.id}
            type="button"
            role="tab"
            onClick={() => setMode(m.id)}
            title={`${m.label} — ${m.sub}`}
            aria-label={`Mudar para modo ${m.label}`}
            aria-pressed={active}
            aria-selected={active}
            data-testid={`mode-pill-${m.id}`}
            data-active={active ? "true" : "false"}
            className={cn(
              "relative h-8 px-2.5 rounded text-[11px] font-mono flex items-center gap-1.5 transition-all cursor-pointer select-none",
              active
                ? "bg-surface-3 text-foreground shadow-[inset_0_0_0_1px_hsl(var(--primary)/0.6)] ring-1 ring-primary/40"
                : "text-muted-foreground hover:text-foreground hover:bg-surface-3/40",
            )}
          >
            <Icon className="w-3.5 h-3.5" style={active ? { color: `hsl(${m.hue} 95% 60%)`, filter: `drop-shadow(0 0 6px hsl(${m.hue} 95% 60%))` } : undefined} />
            <span className="hidden md:inline">{m.label}</span>
          </button>
        );
      })}
    </div>
  );
}
